import React from 'react';
import Icon from '../../../components/AppIcon';

const PrepInsights = ({ interviewType, suggestionsComponent }) => {
    const interviewTypeName = interviewType === 'CODING' ? 'DSA' : (interviewType?.replace(/_/g, ' ') || 'General');

    return (
        <div className="space-y-6">
            <div className="bg-slate-900 rounded-2xl p-6 text-white relative overflow-hidden group">
                <Icon name="Target" size={60} className="absolute -right-2 -bottom-2 text-white/5 group-hover:text-white/10 transition-all duration-500" />
                <h3 className="text-[10px] font-normal tracking-widest text-emerald-400 mb-4">Market Insight</h3>
                <h4 className="text-lg font-normal mb-1">
                    {interviewTypeName}
                </h4>
                <p className="text-slate-400 text-xs leading-relaxed mb-6 italic">
                    Mastering core {interviewTypeName} concepts and standard placement patterns.
                </p>

                <div className="grid grid-cols-2 gap-4">
                    <div className="bg-white/5 rounded-xl p-3 border border-white/10">
                        <p className="text-[10px] font-normal text-slate-500 mb-1">
                            Market Volume
                        </p>
                        <p className="text-sm font-normal text-emerald-400">
                            12.8k+
                        </p>
                    </div>
                    <div className="bg-white/5 rounded-xl p-3 border border-white/10">
                        <p className="text-[10px] font-normal text-slate-500 mb-1">
                            Global Avg
                        </p>
                        <p className="text-sm font-normal text-emerald-400">
                            68.5%
                        </p>
                    </div>
                </div>
            </div>

            {suggestionsComponent}

            <div className="bg-white rounded-2xl border border-slate-100 p-6">
                <h3 className="text-xs font-normal tracking-widest text-slate-900 mb-6 flex items-center gap-2">
                    <Icon name="TrendingUp" size={12} className="text-emerald-500" /> Trending Topics
                </h3>
                <div className="space-y-3">
                    {['System Design', 'DP & Recursion', 'Behavioral Alignment'].map((topic, i) => (
                        <div key={i} className="flex items-center justify-between group cursor-default">
                            <span className="text-[11px] font-normal text-slate-600 group-hover:text-slate-900 transition-colors tracking-tight">{topic}</span>
                            <span className="text-[10px] font-normal text-emerald-500 bg-emerald-50 px-2 py-0.5 rounded-full">Hot</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-100 p-6">
                <h3 className="text-xs font-normal tracking-widest text-slate-900 mb-6 flex items-center gap-2">
                    <Icon name="Users" size={12} className="text-emerald-500" /> Peer Activity
                </h3>
                <div className="flex items-center gap-3">
                    <div className="flex -space-x-2">
                        {[1, 2, 3].map(i => (
                            <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-slate-100 flex items-center justify-center overflow-hidden">
                                <Icon name="User" size={14} className="text-slate-400" />
                            </div>
                        ))}
                    </div>
                    <p className="text-[10px] font-normal text-slate-500 tracking-widest leading-tight">
                        <span className="text-slate-900 font-normal">1.2k+</span> students<br />practicing today
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrepInsights;
